import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import "./index.scss";
import { SearchIcon } from "../../../assets/icons/SearchIcon";
import { LocalisationIcon } from "../../../assets/icons/LocalisationIcon";
import { CategorieIcon } from "../../../assets/icons/CategorieIcon";
import img from "../../../assets/images/emp.png";
import { Rigth } from "../../../assets/icons/Rigth";
import { LeftIcon } from "../../../assets/icons/LeftIcon";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

import { showErrorToaster } from "../../../components/toaster/error";
import MissionService from "../../../services/mission/mission.service";
import { ApplyModal } from "../ApplyModal";
import { useTranslation } from "react-i18next";

const missionService = new MissionService();

export default function Opportunities() {
  const [offers, setOffers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedCards, setExpandedCards] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [showModal, setShowModal] = useState(false);

  const jobsPerPage = 6;
  const { t } = useTranslation();

  // ✅ Charger les missions actives depuis l'API
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await missionService.getAllActiveMission();
        // Sort offers from newest to oldest
        const sortedOffers = (response.data || []).sort((a, b) => {
          // Sort by createdAt if available, otherwise by _id (MongoDB ObjectId contains timestamp)
          let dateA = 0;
          let dateB = 0;
          
          if (a.createdAt) {
            dateA = new Date(a.createdAt).getTime();
          } else if (a._id) {
            // Extract timestamp from MongoDB ObjectId (first 8 characters are timestamp in hex)
            dateA = parseInt(a._id.substring(0, 8), 16) * 1000;
          }
          
          if (b.createdAt) {
            dateB = new Date(b.createdAt).getTime();
          } else if (b._id) {
            // Extract timestamp from MongoDB ObjectId (first 8 characters are timestamp in hex)
            dateB = parseInt(b._id.substring(0, 8), 16) * 1000;
          }
          
          return dateB - dateA; // Newest first
        });
        setOffers(sortedOffers);
      } catch (error) {
        showErrorToaster(t("errors.loadingOffers"));
      }
    };
    fetchOffers();
  }, [t]);

  // ✅ Nettoyer et tronquer le texte HTML
  const getShortText = (html, maxLength = 120) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  // ✅ Afficher / masquer la description
  const toggleDescription = (id) => {
    setExpandedCards((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  // ✅ Appliquer les filtres
  const filteredJobs = offers.filter((job) => {
    const matchSearch =
      job.title?.toLowerCase().includes(searchTerm.toLowerCase()) ?? false;
    const matchLocation =
      !selectedLocation ||
      job.paye?.toLowerCase().includes(selectedLocation.toLowerCase());
    const matchCategory =
      !selectedCategory ||
      job.title?.toLowerCase().includes(selectedCategory.toLowerCase());
    return matchSearch && matchLocation && matchCategory;
  });

  const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);
  const startIndex = (currentPage - 1) * jobsPerPage;
  const currentJobs = filteredJobs.slice(startIndex, startIndex + jobsPerPage);

  return (
    <section className="opportunities-section py-5">
      <Container>
        <h2 className="text-center mb-5">
          {t("opportunities.titleLine11")}
          <br /> {t("opportunities.titleLine22")}
        </h2>

        {/* --- Barre de recherche --- */}
        <div className="search-container mb-5">
          <div className="search-box d-flex align-items-center">
            {/* Recherche par titre */}
            <div className="search-item flex-grow-1">
              <SearchIcon />
              <input
                type="text"
                placeholder={t("opportunities.searchPlaceholder")}
                className="form-control"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>

            {/* Filtre par emplacement */}
            <div className="search-item">
              <LocalisationIcon />
              <select
                className="form-select"
                value={selectedLocation}
                onChange={(e) => {
                  setSelectedLocation(e.target.value);
                  setCurrentPage(1);
                }}>
                <option value="">{t("opportunities.location")}</option>
                <option value="tunis">Tunis</option>
                <option value="paris">Paris</option>
                <option value="remote">{t("opportunities.remote")}</option>
              </select>
            </div>

            {/* Filtre par catégorie */}
            <div className="search-item">
              <CategorieIcon />
              <select
                className="form-select"
                value={selectedCategory}
                onChange={(e) => {
                  setSelectedCategory(e.target.value);
                  setCurrentPage(1);
                }}>
                <option value="">{t("opportunities.category")}</option>
                <option value="design">{t("opportunities.design")}</option>
                <option value="développement">
                  {t("opportunities.development")}
                </option>
                <option value="marketing">
                  {t("opportunities.marketing")}
                </option>
              </select>
            </div>

            <Button className="btn-search">{t("opportunities.search")}</Button>
          </div>
        </div>

        {/* --- Grille d’offres --- */}
        <Row className="g-4">
          {currentJobs.map((job, index) => {
            const jobId = startIndex + index;
            const isExpanded = expandedCards.includes(jobId);

            return (
              <Col lg={4} md={6} sm={12} key={job._id || jobId}>
                <Card className="job-card">
                  <Card.Body className="w-100">
                    {/* --- Status Badge (Top Right) --- */}
                    <div className="status-container">
                      <span
                        className={`status ${
                          job.type === "Disponible" ? "disponible" : "fermee"
                        }`}>
                        {job.type === "Disponible" 
                          ? t("opportunities.status.Disponible", "Disponible")
                          : t("opportunities.status.Fermée", "Fermée")}
                      </span>
                    </div>

                    {/* --- En-tête avec icône bleue --- */}
                    <div className="job-header">
                      <div className="job-icon"></div>
                      <div className="job-header-info">
                        <p className="societe">Msit Conseil</p>
                        <p className="emplacement">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none">
                            <path
                              d="M8 8.66667C9.10457 8.66667 10 7.77124 10 6.66667C10 5.5621 9.10457 4.66667 8 4.66667C6.89543 4.66667 6 5.5621 6 6.66667C6 7.77124 6.89543 8.66667 8 8.66667Z"
                              stroke="currentColor"
                              strokeWidth="1.2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M2 6.66667C2 5.34058 2.52678 4.06881 3.46447 3.13112C4.40215 2.19343 5.67392 1.66667 7 1.66667C8.32608 1.66667 9.59785 2.19343 10.5355 3.13112C11.4732 4.06881 12 5.34058 12 6.66667C12 9.33333 7 14.3333 7 14.3333C7 14.3333 2 9.33333 2 6.66667Z"
                              stroke="currentColor"
                              strokeWidth="1.2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          &nbsp;
                          {job.paye || t("opportunities.remote")}
                        </p>
                      </div>
                    </div>

                    {/* --- Titre --- */}
                    <Card.Title className="job-title">
                      {job.title}
                    </Card.Title>

                    {/* --- Type et Salaire --- */}
                    <div className="job-meta">
                      <span className="temps">{job.typeWork || "Full Time"}</span>
                      {job.typeContrat && (
                        <>
                          <span className="meta-separator">•</span>
                          <span className="prix">{job.typeContrat}</span>
                        </>
                      )}
                    </div>

                    {/* --- Date de création --- */}
                    {job.createdAt && (
                      <div className="job-date mb-2">
                        <small className="text-muted">
                          Publié le: {new Date(job.createdAt).toLocaleDateString('fr-FR', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}
                        </small>
                      </div>
                    )}

                    {/* --- Description (optionnelle) --- */}
                    {job.description && (
                      <div className="description-wrapper">
                        {isExpanded ? (
                          <div
                            className="job-description expanded"
                            dangerouslySetInnerHTML={{
                              __html: job.description,
                            }}
                          />
                        ) : (
                          <p className="job-description">
                            {getShortText(job.description)}
                          </p>
                        )}
                        {job.description && (
                          <div
                            className="toggle-icon"
                            onClick={() => toggleDescription(jobId)}>
                            {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                          </div>
                        )}
                      </div>
                    )}

                    {/* --- Bouton Postuler --- */}
                    <div className="job-footer">
                      <Button
                        className="apply-btn"
                        onClick={() => {
                          setSelectedId(job._id);
                          setShowModal(true);
                        }}>
                        {t("opportunities.apply")}
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>

        {/* --- Pagination --- */}
        {totalPages > 1 && (
          <div className="pagination mt-5 d-flex justify-content-center align-items-center gap-2">
            <Button
              className="style-btn"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}>
              <LeftIcon />
            </Button>

            {[...Array(totalPages)].map((_, index) => (
              <Button
                key={index}
                className={`page-btn ${
                  currentPage === index + 1 ? "active" : ""
                }`}
                onClick={() => setCurrentPage(index + 1)}>
                {index + 1}
              </Button>
            ))}

            <Button
              className="style-btn"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}>
              <Rigth />
            </Button>
          </div>
        )}
      </Container>

      <ApplyModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        jobTitle={selectedId}
      />
    </section>
  );
}
